import React from "react";
interface IProps {
  width?: number;
  height?: number;
  viewBox?: string;
  fill?: string;
}

const AiGuideIcon: React.FC<IProps> = (props) => {
  const { width = 56, height = 40, viewBox = "0 0 58 32", fill = "none" } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_21528_14562)">
        <rect
          x="4"
          width="50.4001"
          height="32.3077"
          rx="16.1539"
          fill="url(#paint0_linear_21528_14562)"
        />
      </g>
      <g clipPath="url(#clip0_21528_14562)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36.0297 20.2347C35.9411 19.9643 35.6917 19.7812 35.4062 19.7812C35.1208 19.7812 34.8714 19.9643 34.7828 20.2347L34.1594 22.1454L32.2497 22.7665C31.9806 22.8545 31.7969 23.1065 31.7969 23.3906C31.7969 23.6748 31.9806 23.9268 32.2497 24.0147L34.1594 24.6359L34.7828 26.5465C34.8714 26.8169 35.1208 27 35.4062 27C35.6917 27 35.9411 26.8169 36.0297 26.5465L36.6531 24.6359L38.5628 24.0147C38.8319 23.9268 39.0156 23.6748 39.0156 23.3906C39.0156 23.1065 38.8319 22.8545 38.5628 22.7665L36.6531 22.1454L36.0297 20.2347ZM19 18.1403C19 18.6197 19.3084 19.0459 19.7645 19.1942L24.5847 20.7607L26.1499 25.5786C26.2975 26.0347 26.7241 26.3438 27.2031 26.3438C27.6822 26.3438 28.1087 26.035 28.2564 25.5786L29.8248 20.7607L34.6417 19.1942C35.0978 19.0459 35.4062 18.62 35.4062 18.1406C35.4062 17.6609 35.0978 17.2353 34.6417 17.087L29.8248 15.5205L28.2564 10.7027C28.1087 10.2463 27.6822 9.9375 27.2031 9.9375C26.7241 9.9375 26.2975 10.2466 26.1499 10.7027L24.5847 15.5205L19.7645 17.087C19.3084 17.2353 19 17.6606 19 18.1403ZM27.2031 11.7067L28.6797 16.2441C28.742 16.4439 28.8995 16.6004 29.0997 16.6654L33.6377 18.1406L29.0997 19.6159C28.8995 19.6808 28.742 19.8374 28.6797 20.0372L27.2031 24.5745L25.7266 20.0372C25.6642 19.8374 25.5067 19.6808 25.3066 19.6159L20.7686 18.1406L25.3066 16.6654C25.5067 16.6004 25.6642 16.4439 25.7266 16.2441L27.2031 11.7067ZM35.4062 22.5598L35.508 22.8689C35.5703 23.0687 35.7278 23.2253 35.928 23.2902L36.2364 23.3906L35.928 23.491C35.7278 23.556 35.5703 23.7125 35.508 23.9123L35.4062 24.2214L35.3045 23.9123C35.2422 23.7125 35.0847 23.556 34.8845 23.491L34.5761 23.3906L34.8845 23.2902C35.0847 23.2253 35.2422 23.0687 35.3045 22.8689L35.4062 22.5598ZM35.7016 6.45347C35.613 6.18309 35.3636 6 35.0781 6C34.7927 6 34.5433 6.18309 34.4547 6.45347L33.5097 9.35442L30.6091 10.2978C30.34 10.3857 30.1562 10.6377 30.1562 10.9219C30.1562 11.206 30.34 11.458 30.6091 11.546L33.5097 12.4893L34.4547 15.3903C34.5433 15.6607 34.7927 15.8438 35.0781 15.8438C35.3636 15.8438 35.613 15.6607 35.7016 15.3903L36.6466 12.4893L39.5472 11.546C39.8162 11.458 40 11.206 40 10.9219C40 10.6377 39.8162 10.3857 39.5472 10.2978L36.6466 9.35442L35.7016 6.45347ZM35.0781 8.77856L35.5014 10.0783C35.567 10.2778 35.7212 10.4343 35.9214 10.4992L37.2208 10.9219L35.9214 11.3445C35.7212 11.4095 35.567 11.566 35.5014 11.7655L35.0781 13.0652L34.6548 11.7655C34.5892 11.566 34.435 11.4095 34.2349 11.3445L32.9355 10.9219L34.2349 10.4992C34.435 10.4343 34.5892 10.2778 34.6548 10.0783L35.0781 8.77856ZM21.625 10.2656H20.9688C20.6078 10.2656 20.3125 10.5596 20.3125 10.9219C20.3125 11.2841 20.6078 11.5781 20.9688 11.5781H21.625V12.2344C21.625 12.5966 21.9203 12.8906 22.2812 12.8906C22.6422 12.8906 22.9375 12.5966 22.9375 12.2344V11.5781H23.5938C23.9547 11.5781 24.25 11.2841 24.25 10.9219C24.25 10.5596 23.9547 10.2656 23.5938 10.2656H22.9375V9.60938C22.9375 9.24712 22.6422 8.95312 22.2812 8.95312C21.9203 8.95312 21.625 9.24712 21.625 9.60938V10.2656Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_21528_14562"
          x="0"
          y="0"
          width="58.4001"
          height="40.3076"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_21528_14562" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_21528_14562"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_21528_14562"
          x1="-0.409969"
          y1="8.07695"
          x2="-3.49178"
          y2="23.2083"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF653D" />
          <stop offset="1" stopColor="#8585FF" />
        </linearGradient>
        <clipPath id="clip0_21528_14562">
          <rect width="21" height="21" fill="white" transform="translate(19 6)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AiGuideIcon;
